import { context } from '@tools/wr-catalog-base'
import htmlTemplate from './template'

const IMAGE_HOST =
  process.env.NODE_ENV === 'development' ? 'https://ptc-v2.catalogs.dev.workrails.com' : window.location.origin

const getCss = async () => {
  const css = (await fetch('/sow-assets/sow-pdf.css').then((v) => v.text())).replace(/\{\{assetHost\}\}/gi, IMAGE_HOST)
  return css
}

export const buildHtml = async (options) => {
  const { cart, cartTotals, formValues, template, asQuoteWord, asQuotePdf } = options

  const css = await getCss()
  const html = htmlTemplate({
    css,
    imageHost: IMAGE_HOST,
    cart,
    cartTotals,
    template,
    formValues,
    region: context.utils.getRegionName(),
    asQuoteWord,
    asQuotePdf,
  })
  return html
}
